<template>
    <v-autocomplete
        ref="r_region"
        v-model="reqRegion"
        :disabled="!req.filter.hosp"
        :clearable="req.filter.hosp"
        color="teal"
        label="Region"
        :items="getReqRegions"
        auto-select-first
        item-text="city_region"
        autocomplete="nope"
        @change="handleChangeReqRegion($event)"
    />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['req', 'member_model'],
    data: ()=>({
        reqRegion: null
    }),
    computed: {
        ...mapGetters(['getReqRegions'])
    },
    watch: {
        'req.region'(newVal) {
            this.reqRegion = newVal
        }
    },
    methods: {
        ...mapActions(['reqProvinces', 'reqCities', 'reqHospClin']),
        handleChangeReqRegion(value) {
            this.req.region = value
            // if (value && this.req.facility && String(this.req.facility.hosp_region).trim() !== String(value).trim()) {
            this.req.province = ''
            this.req.city = ''
            this.req.facility = ''
            this.req.filter.doc = false
            this.req.specField = { sp_name: 'ALL', sp_desc: '' }
            this.req.hospClinDoctor = ''
            // }
            this.reqProvinces({ REGION: value })
            this.reqCities({ REGION: value, PROVINCE: this.req.province })
            this.req.hospClinType = 'H'
            this.req.decking = ''
            this.reqHospClin({ REGION: value, PROVINCE: this.req.province, CITY: this.req.city, TYPE: '', MEMBN: this.member_model.MEMB_N })
        }
    }
}
</script>
